import { render, staticRenderFns } from "./AttendantInstruction.view.vue?vue&type=template&id=cda154ba&scoped=true"
import script from "./AttendantInstruction.view.vue?vue&type=script&lang=js"
export * from "./AttendantInstruction.view.vue?vue&type=script&lang=js"
import style0 from "./AttendantInstruction.view.vue?vue&type=style&index=0&id=cda154ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda154ba",
  null
  
)

export default component.exports